export const irregularCmvProducts = {
	label: "Costo unitario cero",
	layout: {
		goBack: "Volver",
	},
	table: {
		columns: {
			productId: "ID del Producto",
			name: "Producto",
			storage: "Inventario",
			storageId: "ID del Inventario",
			fiscalCode: "SKU",
			lastCost: "Último Costo",
			unitCost: "Costo Unitario",
			edit: "Editar",
		},
		actions: {
			edit: "Editar costo unitario",
		},
	},
	batchActions: {
		title: "Acciones en lote",
		actions: {
			useLastCost: "Utilizar último costo",
			editCost: "Editar costo",
			editViaSpreadsheet: "Editar vía hoja de cálculo",
		},
		caption: "Seleccione productos para acciones en lote",
		useLastCost: {
			title: "Utilizar último costo",
			description: "Los siguientes productos serán afectados:",
			selectedProductsWithoutCost: "Hay productos sin último costo seleccionados",
		},
	},
	updating: {
		title: "Actualizando costos",
		subtitle: "Aguarde, estamos actualizando los costos unitarios",
	},
	editForm: {
		title: "Editar costo",
		inputs: {
			product: "Producto",
			storage: "Inventario",
			lastCost: "Último Costo",
			unitCost: "Costo Unitario",
			save: "Concluir",
			cancel: "Cancelar",
		},
		errors: {
			unitCostValueBiggerThanZero: "El costo unitario debe ser mayor que 0",
		},
	},
	spreadsheetExportModal: {
		title: "Editar costo",
		fileName: "productos-cmv-irregular-{{timestamp}}",
		exportingSuccess: "¡Hoja de cálculo exportada con éxito!",
		exportButton: "Haga clic aquí para descargar la hoja de cálculo",
		currencyWarning:
			"¡Atención! El valor de los productos se informa en centavos, ej: 123 equivale a $ 1,23",
		importButton: "Importar hoja de cálculo",
		closeButton: "Cerrar",
		successTitle: "Actualización realizada con éxito",
		successSubtitle: "Productos fueron actualizados",
		errorTitle: "Ups... Algo no salió como planeado.",
		errorSubtitle:
			"No pudimos realizar la actualización de los productos. Intente nuevamente más tarde.",
	},
};
